import React, { useState, useEffect } from "react";
import { Form, Button, Table, Card, Row, Col } from "@themesberg/react-bootstrap";
import axiosInstance from "../../../api/api";
import CardLayout from "../Layout/CardLayout";
import Ranked from "../Ciem/Ranked";
import InputMask from "react-input-mask";
import { Modal } from "react-bootstrap";
import DetailCompetitor from "./DetailCompetitor";

const Competitor = (ciemId) => {
    const [rankedForm, setRankedForm] = useState([]);
    const [formData, setFormData] = useState({
        id: null,
        competidorDirecto: 0,
        competidorIndirecto: 0,
        porcentajeParticipacion: 0,
        ciemId: ciemId.ciemId,
        valorMonedaLocal: 0,
        valorMonedaExtranjera: 0
    });

    const [tableHeaders, setTableHeaders] = useState([]);

    useEffect(() => { // Reemplaza con la URL de tu API de títulos
        if (ciemId.ciemId) {
            axiosInstance.get('demanda/competitor/' + ciemId.ciemId).then((response) => {
                //console.log(response.data.data)
                if (response.data.data) {
                    setFormData(response.data.data);
                }
                //console.log("informacion guardada" + formData)
            }).catch((e) => {
                //console.log(e)
                alert("Mensaje del sistema " + e.message)
            });
        }

        axiosInstance.get('/detailoption/option/value/rankedFive').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });

    }, []);

    // Función que el hijo usará para actualizar el estado del padre
    const refrescar = () => {
        if (ciemId.ciemId) {
            axiosInstance.get('demanda/competitor/' + ciemId.ciemId).then((response) => {
                //console.log(response.data.data)
                if (response.data.data) {
                    setFormData(response.data.data);
                }
                //console.log("informacion guardada" + formData)
            }).catch((e) => {
                //console.log(e)
                alert("Mensaje del sistema " + e.message)
            });
        }
    };



    const contributionForm = <Form>
        <Row>
            <Col md={6}>
                <Form.Group controlId="continente">
                    <Form.Label>Numero de competidores directos</Form.Label>
                    <Form.Control
                        type="text"
                        name="competidorDirecto"
                        value={formData.competidorDirecto}
                        readOnly={true}
                    />
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group controlId="moneda">
                    <Form.Label>Número de competidores indirectos:</Form.Label>
                    <Form.Control
                        type="text"
                        name="competidorIndirecto"
                        value={formData.competidorIndirecto}
                        readOnly={true}
                    />
                </Form.Group>
            </Col>
        </Row>
        <p></p>
        <h3>Listado de competidores</h3>
        <DetailCompetitor competitorId={formData} refrescar={refrescar} />
        <p></p>
        <h3>Totales</h3>
        <Table striped bordered>
            <tbody>
                <tr>
                    <td>Porcentaje total de participación en el mercado objetivo competidores actuales</td>
                    <td>{formData.porcentajeParticipacion}</td>
                </tr>
                <tr>
                    <td>Valor en moneda local de la participación en el mercado objetivo tomado por competidores actuales (a):</td>
                    <td>{formData.valorMonedaLocal}</td>
                </tr>
                <tr>
                    <td>Valor en dólares (USD) :</td>
                    <td>{formData.valorMonedaExtranjera}</td>
                </tr>
            </tbody>
        </Table>

    </Form>
        ;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"competitorTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedFive"} tablaComponent={calificacion} />
        </div>
    );
};

export default Competitor;
